import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/Link'
import CloudinaryMedia from 'components/CloudinaryMedia'

import s from './ArticleItem.module.css'
import formatDate from '../../helpers/formatDate'

function ArticleItem({
  title = '',
  slug = '',
  date = '',
  acfPost = {},
  acfPostSettings = {},
  feature = false,
  landscapeImg = false,
  className = '',
}) {
  const img = acfPost?.featuredImage
  const imgUrl = img?.node?.mediaItemUrl
  const categories = acfPostSettings?.globalCategoriesTag?.nodes
  const relatedModels = acfPostSettings?.relatedModels?.nodes

  const setImgSize = () => {
    let mobile = 'w_514'
    let desktop = 'w_270'

    if (feature) {
      mobile = 'w_656'
      desktop = 'w_853'
    } else if (landscapeImg) {
      mobile = 'w_656'
      desktop = 'w_656'
    }

    return {
      mobile,
      desktop,
    }
  }

  // TODO: at the very tail end of the project it was asked to split titles by pipe.
  // This is used in <ArticlesRelated/> so you can make a component to unify this.

  const setRelatedModels = relatedModels
    ?.map((rm) => rm.title)
    .join(', ')
    .replace(/,(?!.*,)/gim, ' &')

  return (
    <div className={classNames(s.container, className)}>
      <Link type="Article" href={slug} className={s.link}>
        {imgUrl && (
          <CloudinaryMedia
            className={s.img}
            images={[
              { url: imgUrl, params: `${setImgSize().mobile},f_auto` },
              { url: imgUrl, params: `${setImgSize().desktop},f_auto` },
            ]}
          />
        )}
        {relatedModels && (
          <h2
            className={s.title}
            dangerouslySetInnerHTML={{ __html: setRelatedModels }}
          />
        )}
        {title && (
          <h3
            className={s.subtitle}
            dangerouslySetInnerHTML={{
              __html: title.substr(0, title.lastIndexOf('|')) || title,
            }}
          />
        )}
        {date && (
          <span className={s.created}>{formatDate(new Date(date))}</span>
        )}
      </Link>
      <div className={s.tags}>
        {categories?.slice(0, 3).map(({ name, slug }) => (
          <Link key={slug} type="Category" href={slug} className={s.tag}>
            <span dangerouslySetInnerHTML={{ __html: name }} />
          </Link>
        ))}
      </div>
    </div>
  )
}

ArticleItem.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  date: PropTypes.string,
  acfPost: PropTypes.object,
  acfPostSettings: PropTypes.object,
  feature: PropTypes.bool,
  landscapeImg: PropTypes.bool,
  className: PropTypes.string,
}

export default ArticleItem
